import { useState } from "react";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";

import { AppWrap } from "./../../HOC/AppWrap";
import { MotionWrap } from "./../../HOC/MotionWrap";

import images from "../../../constants/images";

import "./Skill.scss";

const Skill = () => {
  const [experience] = useState([
    {
      name: "Estudios",
      dates: "",
      year: "2011 - 2019",
      targetTooltip: "2011",
      company: "Dev",
      desc: "En mi secundaria estudié en una Escuela Técnica en Informática. Dando inicio a mi integración al mundo de la programación, comenzando con programas logísticos hasta la creación de paginas web responsive  y servidores, usando tecnologías como   PHP, MySql, Bootstrap, Css3, Html5, JavaScrip y Jquery. A partir de 4to año empecé a participar en olimpiadas de programación que se basan en c++, no era mi fuerte pero quería obtener experiencia, en comunicación de arduino con el servidor echo en PHP y MySql. En mis últimos años tuve la oportunidad de participar en un proyecto de pymes de la provincia haciendo desarrollo web, tambien participaba en talleres lo cual a veces ayudaba con la clase al profesor. A todo esto me recibi de Tecnico Profesional en informática :D, al año de recibirme por motivos personales no pude ir a la facultad :’c, pero no me quedé atrás, empecé a ver cursos  en plataformas online como Udemy y Platzi para seguir mejorando mis habilidades en el desarrollo web. Cuando tenía la oportunidad hacía unos que otro trabajo freelance en PHP. A inicio del 2018 conocí ReactJs, fue un nuevo mundo y reto para mí, me dediqué un año y meses en hacer proyectos personales en React con todas sus variantes en: enrutado,functional/class components, framework UI, ect.",
    },
    {
      name: "Panbox",
      dates: "oct - dic",
      year: "2020 - 2020",
      targetTooltip: "2020",
      company: "Regalistos",
      desc: "tuve la oportunidad de trabajar en el desarrollo de una web app llamada regalistos. Las tecnologías que usamos para la contruccion de la app fueron: Nextjs, material UI y redux. Teniamos un excelente scrummaster y un buen diseño en figma.",
    },
    {
      name: "Freelance",
      dates: "",
      year: "2021 - 2022",
      targetTooltip: "2021",
      company: "Dev",
      desc: "Cuando tenía tiempo extra por las noches me quedaba haciendo freelance o mejorando mis skills. Uno de los freelance que me tocó trabajar fue aportar optimización en un sistema control de asistencia y cambio de roles, lo cual el proyecto fue hecho en react, hooks react, ContextAPI y Material UI.",
    },
    {
      name: "Uneio",
      dates: "dic - abr",
      year: "2020 - 2022",
      targetTooltip: "2022",
      company: "Dev",
      desc: "Trabajé como desarrollador en una empresa de Ecuador que me dio la oportunidad de crecer profesionalmente, aprendiendo cosas nuevas como aws cli, servicios de amazon, mejorar mis habilidades en react hooks y implementar diseños propios, en este caso no contábamos con un diseño elaborado ni scrummaster. Hice diversas tareas como desarrollador de apps, maquetación web o de plantillas para pdf y algunas apps en react native.",
    },
  ]);
  const [skills] = useState([
    {
      name: "GitHub",
      bgColor: "#edf2f8",
      icon: images.git,
    },
    {
      name: "React",
      bgColor: "#edf2f8",
      icon: images.react,
    },
    {
      name: "Sass",
      bgColor: "#edf2f8",
      icon: images.sass,
    },
    {
      name: "Node JS",
      bgColor: "#edf2f8",
      icon: images.node,
    },
    {
      name: "Redux",
      bgColor: "#edf2f8",
      icon: images.redux,
    },
    {
      name: "HTML",
      bgColor: "#edf2f8",
      icon: images.html,
    },
    {
      name: "CSS3",
      bgColor: "#edf2f8",
      icon: images.css,
    },
    {
      name: "MUI",
      bgColor: "#edf2f8",
      icon: images.mu5,
    },
    {
      name: "C++",
      bgColor: "#edf2f8",
      icon: images.cpp,
    },
    {
      name: "API",
      bgColor: "#edf2f8",
      icon: images.api,
    },
    {
      name: "JavaScript",
      bgColor: "#edf2f8",
      icon: images.javascript,
    },
    {
      name: "Bootstrap",
      bgColor: "#edf2f8",
      icon: images.bootstrap,
    },
    {
      name: "PHP",
      bgColor: "#edf2f8",
      icon: images.php,
    },
    {
      name: "Tailwind CSS",
      bgColor: "#edf2f8",
      icon: images.tailwind,
    },
    {
      name: "Next JS",
      bgColor: "#edf2f8",
      icon: images.next,
    },
    {
      name: "AWS",
      bgColor: "#edf2f8",
      icon: images.aws,
    },
    {
      name: "CLI",
      bgColor: "#edf2f8",
      icon: images.terminal,
    },
    {
      name: "MYSQL",
      bgColor: "#edf2f8",
      icon: images.mysql,
    },
    {
      name: "Firebase",
      bgColor: "#edf2f8",
      icon: images.firebase,
    },
  ]);

  return (
    <>
      <h2 className="head-text" style={{ marginTop: 30 }}>
        Habilidades y <span>Experiencias</span>
      </h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, index) => (
            <motion.div
              key={index}
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="app__skills-exp">
          {experience.map((work, index) => (
            <>
              <motion.div key={index} className="app__skills-exp-item">
                <div className="app__skills-exp-year">
                  <span
                    className="p-text"
                    style={{ textTransform: "capitalize" }}
                  >
                    {work.dates}
                  </span>
                  <p className="bold-text">{work.year}</p>
                </div>

                <motion.div className="app__skills-exp-works">
                  <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 0.5 }}
                    className="app__skills-exp-work"
                    data-tip
                    data-for={work.targetTooltip}
                  >
                    <h4 className="bold-text">{work.name}</h4>
                    <p className="p-text">{work.company}</p>
                  </motion.div>
                  <ReactTooltip
                    id={work.targetTooltip}
                    effect="solid"
                    arrowColor="#fff"
                    place="top"
                    className="skills-tooltip"
                  >
                    {work.desc}
                  </ReactTooltip>
                </motion.div>
              </motion.div>
            </>
          ))}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(MotionWrap(Skill, "app__skills"), "skills");
